module.exports = __webpack_public_path__ + "img/ic_property_type.5b1e7efa.svg";